// extracted by mini-css-extract-plugin
export var blue = "_2h-f";
export var brand = "_2h-b";
export var darkGrey = "_2h-e";
export var disabled = "_2h-4";
export var disabledSubtle = "_2h-5";
export var error = "_2h-6";
export var green = "_2h-g";
export var grey = "_2h-d";
export var icon = "_2h-0";
export var inherit = "_2h-a";
export var lightGrey = "_2h-c";
export var orange = "_2h-i";
export var pink = "_2h-k";
export var primary = "_2h-1";
export var purple = "_2h-l";
export var red = "_2h-j";
export var secondary = "_2h-2";
export var success = "_2h-9";
export var tertiary = "_2h-3";
export var warning = "_2h-7";
export var warningSecondary = "_2h-8";
export var white = "_2h-m";
export var yellow = "_2h-h";